var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 2.08325C10.6049 2.08325 2.58334 10.1048 2.58334 19.9999C2.58334 29.8951 10.6049 37.9166 20.5 37.9166C30.3952 37.9166 38.4167 29.8951 38.4167 19.9999C38.4167 10.1048 30.3952 2.08325 20.5 2.08325ZM22.1667 13.3333C22.1667 12.4128 21.4205 11.6666 20.5 11.6666C19.5795 11.6666 18.8333 12.4128 18.8333 13.3333V19.9999C18.8333 20.4419 19.009 20.8659 19.3215 21.1784L22.6548 24.5118C23.3057 25.1626 24.361 25.1626 25.0118 24.5118C25.6627 23.8609 25.6627 22.8056 25.0118 22.1548L22.1667 19.3096V13.3333Z",
    fill: "#B0B9CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock01);
export default __webpack_public_path__ + "static/media/clock-01.a95d720ae2863f1fe3cc23887b669af8.svg";
export { ForwardRef as ReactComponent };